import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-brand.svg'


const _hoisted_1 = { class: "min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 p-7" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:mx-auto sm:w-full md:max-w-lg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mx-auto",
    src: _imports_0,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-10 text-center text-5xl font-extrabold" }, "Log in")
], -1)
const _hoisted_3 = { class: "mt-12 sm:mx-auto sm:w-full sm:max-w-md md:max-w-3xl" }
const _hoisted_4 = { class: "bg-white py-16 px-14 shadow sm:rounded-lg" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-2xl font-medium text-gray-700"
}, " Email address ", -1)
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-2xl font-medium text-gray-700"
}, " Password ", -1)
const _hoisted_8 = { class: "mt-2 relative" }
const _hoisted_9 = ["type"]
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "remember-me",
  class: "ml-2 block text-2xl text-gray-900"
}, " Remember me ", -1)
const _hoisted_13 = { class: "text-2xl" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Forgot your password? ")
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_EyeOffIcon = _resolveComponent("EyeOffIcon")!
  const _component_ErrorDisplay = _resolveComponent("ErrorDisplay")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "space-y-6",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", null, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  name: "email",
                  type: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.email) = $event)),
                  required: "",
                  class: "input-auth"
                }, null, 512), [
                  [_vModelText, _ctx.loginForm.email]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  name: "password",
                  type: _ctx.passwordType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                  required: "",
                  class: "input-auth"
                }, null, 8, _hoisted_9), [
                  [_vModelDynamic, _ctx.loginForm.password]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "absolute password_stat",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.passwordType === 'password'
                      ? (_ctx.passwordType = 'text')
                      : (_ctx.passwordType = 'password')
                  ))
                }, [
                  _withDirectives(_createVNode(_component_EyeIcon, { class: "h-8" }, null, 512), [
                    [_vShow, _ctx.passwordType === 'text']
                  ]),
                  _withDirectives(_createVNode(_component_EyeOffIcon, { class: "x h-8" }, null, 512), [
                    [_vShow, _ctx.passwordType === 'password']
                  ])
                ])
              ])
            ]),
            (_ctx.isError)
              ? (_openBlock(), _createBlock(_component_ErrorDisplay, {
                  key: 0,
                  "error-message": _ctx.errorMessage
                }, null, 8, ["error-message"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  id: "remember-me",
                  name: "remember-me",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checked) = $event)),
                  class: "h-4 w-4 text-pri focus:ring-focus_border border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.checked]
                ]),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: "/reset-password",
                  class: "font-medium text-success hover:text-pri"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "submit",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleLogin())),
                class: _normalizeClass(["btn-main", [{ disabled: _ctx.isDisabled || _ctx.isLoading }]]),
                disabled: _ctx.isDisabled || _ctx.isLoading
              }, _toDisplayString(!_ctx.isLoading ? ' Log in' : 'Processing...'), 11, _hoisted_15)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}